import React from 'react';
import PropTypes from 'prop-types';

import Card from '../../../components/Card/Card';
import EmptyRelatedBlock from './EmptyRelatedBlock';
import ArticlesRelatedListingsTable from './ArticlesRelatedListingsTable';
import ArticlesRelatedListingsModal from './ArticlesRelatedListingsModal';

const containerClassName = '';
const cardBodyClassName = 'px-[30px] pb-[30px]';
const cardContainerClassName = 'flex-none mb-[40px]';

const ArticlesRelatedListings = ({ relatedItem, setFieldValue }) => (
  <div className={containerClassName}>
    <Card
      headerTitle="Related listing"
      showHeader
      styleBodyContainer={cardBodyClassName}
      styleContainer={cardContainerClassName}
      headerBordered={false}
    >
      {!!relatedItem?.length && (
        <ArticlesRelatedListingsTable
          relatedItem={relatedItem}
          setFieldValue={setFieldValue}
        />
      )}
      {!relatedItem?.length
         && <EmptyRelatedBlock />}
    </Card>
    <ArticlesRelatedListingsModal
      selectedListing={relatedItem}
      setFieldValue={setFieldValue}
    />
  </div>
);

ArticlesRelatedListings.propTypes = {
  relatedItem: PropTypes.arrayOf(PropTypes.shape({})),
  setFieldValue: PropTypes.func
};

ArticlesRelatedListings.defaultProps = {
  relatedItem: null,
  setFieldValue: () => {}
};

export default ArticlesRelatedListings;
